// extracted by mini-css-extract-plugin
module.exports = {"ShareMockup":"Share_ShareMockup__27FXm"};